import { lazy } from "react";

export type { IEditNichePopupContainerProps } from "./types";

export const EditNichePopup = lazy(() => import("./EditNichePopupContainer"));
